import { useState } from 'react';
import TextField from '@mui/material/TextField';
import EntityDetailPopup from '../../utility/EntityDetailPopup';
import { popupClasses } from '../../utility/constants';

const vehicleKeys = ['vehicle_make', 'vehicle_model', 'vehicle_license_plate_number'];

export default function VehicleEntryPopup(props) {
  const { handleVehicleSave, handleSetSelVehicle, selVehicle, farmName, currDarkThemeClass = '', ...otherProps } = props;

  const [loading, setLoading] = useState(false);

  const vehicleEntryTextFieldProps = ({ prop, inputProps = {}, otherTextProps = {} }) => ({
    autoComplete: 'off',
    className: `${popupClasses?.strainEntry?.textField} ${currDarkThemeClass}`,
    disabled: !otherProps?.toShowSave || loading,
    fullWidth: true,
    inputProps,
    label: ' ',
    onChange: ({ target: { value } }) => handleSetSelVehicle(prop, value),
    required: true,
    readOnly: false,
    value: selVehicle?.[prop] ?? '',
    ...otherTextProps,
  });

  const handleVehicleEntrySave = async () => {
    if (vehicleKeys.some(key => !selVehicle?.[key])) {
      return;
    }

    setLoading(true);

    let res = { success: false };

    try {
      res = await handleVehicleSave(selVehicle);
    } catch (error) {
      console.error('Error saving vehicle:', error);
    } finally {
      setLoading(false);
    }

    if (res?.success) {
      otherProps?.onClose?.();
    }
  };

  const entityDetailProps = {
    currDarkThemeClass,
    loading,
    headContentText: selVehicle?.id ? `Edit Vehicle: ${selVehicle?.vehicle_make} ${selVehicle?.vehicle_model}` : 'Add New Vehicle',
    onSaveClick: handleVehicleEntrySave,
    ...otherProps,
  };

  const farmNameProps = {
    otherTextProps: {
      label: 'Farm',
      disabled: true,
    },
    prop: 'farmName',
    inputProps: {
      readOnly: true,
    },
  };

  const vehicleMakeProps = {
    otherTextProps: {
      autoFocus: true,
      label: 'Make',
    },
    prop: 'vehicle_make',
  };

  const vehicleModelProps = {
    otherTextProps: {
      label: 'Model',
    },
    prop: 'vehicle_model',
  };

  const vehicleLicensePlateProps = {
    otherTextProps: {
      label: 'License Plate Number',
    },
    prop: 'vehicle_license_plate_number',
  };

  return (
    <EntityDetailPopup {...entityDetailProps}>
      {farmName && <TextField {...vehicleEntryTextFieldProps(farmNameProps)} value={farmName} disabled />}
      <TextField {...vehicleEntryTextFieldProps(vehicleMakeProps)} />
      <TextField {...vehicleEntryTextFieldProps(vehicleModelProps)} />
      <TextField {...vehicleEntryTextFieldProps(vehicleLicensePlateProps)} />
    </EntityDetailPopup>
  );
}
